import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { client } from "../client";
import { homePageJobsQuery } from "../utils/Data";
import Card from "./Card";
import site from "../site.json";
import { feature } from "../utils/features";
import { LoadingBlock } from "./Spinner";

function JobCardRender(job) {
  return (
    <Card
      key={job._id}
      btnId={job._id}
      title={job.title}
      companyName={job.companyName}
      categories={job.categories}
      city={job.city}
      salary={job.salary}
      postedOn={job.postedOn}
      externalUrl={job.url}
      source={job.source}
      postExpiry={job.postExpiry}
    />
  );
}

function Jobs() {
  const [jobsArr, setJobsArr] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect (() => {
    
      client
        .fetch(homePageJobsQuery)
        .then((jobs) => {
          setJobsArr(jobs);
        })
        .catch((err) => console.log(err))
        .finally(() => setLoading(false));
      
    
  },[])
  

  if (feature("modernCards")) {
    return (
      <section aria-labelledby="latest" className="bg-white py-20">
        <div className="mx-auto max-w-6xl px-5">
          <div className="flex flex-wrap items-end justify-between gap-4">
            <div>
              <h2 id="latest" className="font-display text-3xl font-bold text-gray-900">Latest jobs</h2>
              <p className="mt-2 text-gray-600">{site.jobsTagline}</p>
            </div>
            <Link to="/jobs" className="inline-flex items-center gap-1 font-semibold text-primary-dark hover:underline">
              See all jobs <span aria-hidden="true">→</span>
            </Link>
          </div>
          {loading ? (
            <LoadingBlock label="Loading jobs…" minHeight="min-h-[24rem]" />
          ) : (
            <div className="mt-8 grid gap-x-4 md:grid-cols-2">{jobsArr.map(JobCardRender)}</div>
          )}
        </div>
      </section>
    );
  }

  return (
    <section className="text-gray-600 body-font">
      <div className="container px-5 py-24 mx-auto">
        <div className="flex flex-wrap w-full mb-20 flex-col items-center text-center">
          <h1 className="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">
            Latest Postings
          </h1>
          <p className="lg:w-1/2 w-full leading-relaxed text-gray-500">
            {site.jobsTagline}
          </p>
        </div>

        
        {loading ? <LoadingBlock label="Loading jobs…" minHeight="min-h-[24rem]" /> : jobsArr.map(JobCardRender)}

        <Link to="/jobs">
          <button className="flex mx-auto mt-16 text-white font-[Poppins] bg-primary px-6 py-1 rounded-lg border-2 border-primary hover:text-primary-dark hover:bg-white ease-in duration-150 text-lg">
            See All
          </button>
        </Link>
      </div>
    </section>
  );
}

export default Jobs;
